module.exports = {"ru":{"loadingText":"Загрузка...","errorLoading":"Невозможно показать контент","goToSourceLink":"Перейти к источнику"},"en":{"loadingText":"Loading...","errorLoading":"Impossible to view the content","goToSourceLink":"Go to source"}}


//////////////////
// WEBPACK FOOTER
// ./temp/components/note-frames/.variant/page-content-preview/text.yaml
// module id = 200
// module chunks = 0